/** Why a move did not happen. The screen shows the matching `phone.problem_*` line. */
export const MoveProblem = {
    /** More than a slot takes, even without the chats. */
    too_big: "too_big",
    /** The scanned QR is not a move code (a personal QR, or something else). */
    not_move: "not_move",
    /** The code was used already, or never existed: the old phone makes a new one. */
    gone: "gone",
    /** The 15 minutes ran out. */
    expired: "expired",
    /** The code came from this same phone. */
    same_phone: "same_phone",
    /** The code is for another number than the one signed in here. */
    not_yours: "not_yours",
    /** The old phone runs a newer GigSync, whose records this one cannot read yet. */
    newer: "newer",
    /** The old phone's records did not arrive whole. */
    damaged: "damaged",
    /** The old phone's account is the other role (worker or household) than the one signed in here. */
    other_role: "other_role",
    /** Too many codes this hour. */
    too_many: "too_many",
};
/** A move step this phone will not take, or the server refused; `problem` says which. */
export class MoveError extends Error {
    problem;
    constructor(problem) {
        super(`move refused: ${problem}`);
        this.problem = problem;
    }
}
//# sourceMappingURL=types.js.map